import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {CharacterCounterComponent} from "../character-counter/character-counter.component";
import {FormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";

import {TextAreaComponent} from "../text-area/text-area.component";

@Component({
    selector: 'app-ard-popnacht-text-area',
    imports: [
    CharacterCounterComponent,
    FormsModule,
    MatFormFieldModule,
    MatInputModule
],
    templateUrl: './ard-popnacht-text-area.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './ard-popnacht-text-area.component.css'
})
export class ArdPopnachtTextAreaComponent extends TextAreaComponent {
  @Input() copyFromIds: string[] | undefined;
  @Output() copyEvent = new EventEmitter<string[]>();


  fireCopyEvent($event: MouseEvent) {
    //console.log("FIRE_COPYEVENT :" + $event.target);
    if(this.copyFromIds) {
      //console.log("FIRE_COPYEVENT COPY_IDs: " + this.copyFromIds.length);
      this.copyEvent.emit(this.copyFromIds);
    }
  }
}
